import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { messages } from '@/utils/lang'

import { App as CapApp } from '@capacitor/app'
import { Capacitor } from '@capacitor/core'
import { StatusBar, Style } from '@capacitor/status-bar'

if (Capacitor.getPlatform() === 'android') {
  StatusBar.setBackgroundColor({ color: '#99B6FE' })
  StatusBar.setStyle({ style: Style.Light })
  StatusBar.setOverlaysWebView({ overlay: false })
}

if (Capacitor.getPlatform() === 'android') {
  CapApp.addListener('backButton', ({ canGoBack }) => {
    // 1) اول اجازه بده UI (مودال/توست) Back رو مصرف کنه
    const uiEvt = new Event('app-back-pressed', { cancelable: true })
    window.dispatchEvent(uiEvt)
    if (uiEvt.defaultPrevented) return

    const routeName = router.currentRoute.value?.name

    // ---------- دانش‌آموز ----------
    const STUDENT_EXIT_CONFIRM = new Set([
      'Splash',
      'Language',
      'Login',
      'Otp',
      'Register',
      'Home',
    ])

    const STUDENT_GO_HOME = new Set([
      'GradesList',
      'Bookmarks',
      'UserProfile',
    ])

    // ---------- استاد ----------
    const TEACHER_EXIT_CONFIRM = new Set([
      'TeacherLogin',
      'TeacherOtp',
      'TeacherRegister',
      'TeacherHome',
    ])

    const TEACHER_GO_HOME = new Set([
      'TeacherUserArea',
      'TeacherMyProfile',
      'TeacherMyChats',
      'TeacherAddPost',
      'TeacherAttachReport',
      'TeacherChatDetail',
      'TeacherCourseQA',
      'TeacherEditProfileInfo',
      'TeacherExamList',
      'TeacherFollowersList',
      'TeacherLikesList',
      'TeacherPostDetail',
      'TeacherReportDetail',
      'TeacherRequestSubject',
      'TeacherStatus',
      'TeacherContact',
    ])

    const IGNORE = new Set([])

    if (IGNORE.has(routeName)) return

    // 2) صفحه‌هایی که باید سوال خروج بپرسن (ولی ما خروج واقعی نمی‌کنیم؛ می‌بریم پس‌زمینه)
    if (STUDENT_EXIT_CONFIRM.has(routeName)) {
      window.dispatchEvent(new CustomEvent('app-exit-request', { detail: { mode: 'student' } }))
      return
    }

    if (TEACHER_EXIT_CONFIRM.has(routeName)) {
      window.dispatchEvent(new CustomEvent('app-exit-request', { detail: { mode: 'teacher' } }))
      return
    }

    // 3) صفحه‌هایی که باید برن Home
    if (STUDENT_GO_HOME.has(routeName)) {
      router.replace({ name: 'Home' })
      return
    }

    if (TEACHER_GO_HOME.has(routeName)) {
      router.replace({ name: 'TeacherHome' })
      return
    }

    // 4) حالت پیش‌فرض
    if (canGoBack) router.back()
    else router.replace({ name: 'Home' })
  })
}

if (typeof window.ResizeObserver === 'undefined') {
  window.ResizeObserver = class ResizeObserver {
    observe() {}
    unobserve() {}
    disconnect() {}
  }
}

const app = createApp(App)

app.mixin({
  methods: {
    t(key) {
      const lang = localStorage.getItem('app_lang') || 'fa'
      const dict = messages[lang] || messages['fa']
      return dict[key] || key
    },
    notify(message, type = 'info') {
      window.dispatchEvent(new CustomEvent('app-notify', { detail: { message, type } }))
    }
  }
})

app.use(router).mount('#app')
